import { render, staticRenderFns } from "./EmarPatientVitalsV1Properties.vue?vue&type=template&id=7ce084a8&"
import script from "./EmarPatientVitalsV1Properties.vue?vue&type=script&lang=js&"
export * from "./EmarPatientVitalsV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports